import { makeStyles } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    padding: "10px 10px",
  },
  dividerContainer: {
    height: "20px",
  },
  dividerText: {
    color: "#242424",
    fontSize: "12px",
    lineHeight: "16px",
    wordWrap: "break-word",
    textTransform: "capitalize",
  },
  searchTextPlaceholderContainer: {
    display: "flex",
    flexDirection: "column",
    rowGap: "10px",
    padding: "10px 6px",
  },
  suggestionListContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    rowGap: "16px",
    minHeight: "min-content",
    padding: "10px 5px",
    overflowY: "auto",
    overflowX: "hidden",
  },
  overlay: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    height: "100vh",
    width: "100%",
    backgroundColor: "rgba(0,0,0, 0.5)",
    backdropFilter: "10px",
    zIndex: 1,
    transition: "display 5s inherit ease-in-out",
  },
  displayNone: { display: "none" },
  popOverTrigger: {
    position: "relative",
    minWidth: "36px",
    paddingRight: "5px",
  },
  popOverTriggerActive: {
    position: "absolute",
    right: "15px",
    top: "10px",
    zIndex: "1000",
    borderRadius: "1000px",
    backgroundColor: "white",
    "&:hover": {
      backgroundColor: "white",
    },
  },
  popOverTriggerBadge: {
    position: "absolute",
    top: "0px",
    left: "0px",
  },
  disabledTrigger: {
    visibility: "hidden",
  },
  cardContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    backgroundColor: "rgba(211, 211, 211, 0.3)",
  },
  card: {
    backgroundColor: "transparent",
  },
  textContainer: {
    overflow: "auto",
    whiteSpace: "pre-wrap",
    cursor: "text",
    userSelect: "text",
    display: "-webkit-box",
    WebkitLineClamp: 7,
    WebkitBoxOrient: "vertical",
    maxHeight: "200px",
    "&::selection": {
      backgroundColor: "#242424",
      color: "#fff",
    },
  },
});
